<template>
    <div :class="{loading: loading.data}">
        <div v-if="data && data.data && data.data.length > 0"
             class="card">
            <div class="card-body p-0">
                <template >
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Hero's name</th>
                                <th>Email address</th>
                                <th>Admin</th>
                                <th>Team members</th>
                                <th width="116"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="user in data.data" v-bind:key="user.email">
                                <td>
                                    <router-link :to="{ name: 'hero.details', params: {hero_id: user.id}}" style="text-decoration: none">
                                        <user-avatar size="small" :user="user" :displayName="true"></user-avatar>
                                    </router-link>
                                </td>
                                <td>
                                    {{ user.email }}
                                </td>
                                <td>
                                    {{ user.main_caregiver.name }}
                                </td>
                                <td>
                                    <avatar-group v-if="user.team_members" hidePlusIcon="true" size="xs" :users="user.team_members"></avatar-group>
                                </td>
                                <td>
                                    <div class="d-flex flex-row align-items-center gap-1">
                                        <a @click.prevent="showRemoveHeroModal(user)"
                                           class="card-link link-black"
                                           href="#">
                                            Remove
                                        </a>
                                        <btn class="btn-light-primary"
                                             @click="$router.push({name: 'hero.details', params: {hero_id: user.id}})">
                                            See Details
                                        </btn>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </div>
            <div class="d-flex mt-2" v-if="data && data.total > 1">
                <pagination :limit="10" :data="data" v-on:pagination-change-page="getPage"></pagination>
            </div>
        </div>
        <div v-else-if="!loading.data && data && !data.data.length" class="no-data mt-5">
            <inline-svg src="/assets/img/no-heroes.svg"></inline-svg>
            <div class="no-data-title mt-4 mb-1">No Heroes yet</div>
            <div class="no-data-subtitle mb-4">Add a hero to start scheduling Card Decks and tracking progress.</div>
            <btn class="btn btn-primary" @click="$modal.show('addHeroModal')">
                <inline-svg class="me-1" src="/assets/img/icons/plus.svg"></inline-svg>
                Add a Hero
            </btn>
        </div>
        <modal name="removeHeroAsAdminModal" height="auto" width="500px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column">
                    <inline-svg class="mb-2" src="/assets/img/icons/trash-circle-red.svg"></inline-svg>
                    <h4 class="modal-title">Remove {{selectedHero.name}}?</h4>
                    <div class="modal-subtitle-gray">Are you sure you want to remove this Hero?</div>
                </div>
                <div class="divider --top-20"></div>
                <div class="modal-body text-center">
                    <h4 class="modal-subtitle-gray">or</h4>
                    <h4 class="modal-title">Change the Account Administrator</h4>
                    <div class="modal-subtitle-gray mt-2">If you wish to simply transfer the Hero to another Administrator (not delete their account), you can select their new Administrator here:</div>
                </div>
                <div class="modal-body d-flex flex-column align-items-center" :class="{'loading': loading.selectedHeroCaregivers}">
                    <div>
                        <div class="d-flex flex-row justify-content-left align-items-center mb-2" v-for="caregiver in selectedHeroCaregivers">
                            <input class="form-check-input me-1" type="radio" name="radioBtn" :value="caregiver" :id="caregiver.id" v-model="selectedCaregiver">
                            <user-avatar :user="caregiver" size="small" :displayName="true"></user-avatar>
                        </div>
                    </div>
                </div>
                <div class="divider --top-12"></div>
                <div class="d-flex flex-column gap-2 p-3" >
                    <div class="d-flex flex-row justify-content-between gap-2">
                        <btn class="btn-outline-light btn-lg flex-1" @click="$modal.hide('removeHeroAsAdminModal')">Cancel</btn>
                        <btn class="btn-primary btn-lg flex-1"
                             :class="{'loading': loading.add }"
                             :disabled="!selectedCaregiver.id"
                             @click="makeAdmin">Make admin
                        </btn>
                    </div>
                    <btn class="btn-light-primary danger btn-lg flex-1"
                         :class="{'loading': loading.add }"
                         @click="removeHero(true)">
                        <inline-svg height="20" src="/assets/img/icons/trash-01-red.svg"></inline-svg>
                        Remove the Hero anyway
                    </btn>
                </div>
            </div>
        </modal>

        <modal name="removeHeroModal" height="auto" width="500px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column">
                    <div class="w-100 text-center" style="position: relative">
                        <inline-svg class="mb-2" src="/assets/img/icons/trash-circle-red.svg"></inline-svg>
                        <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                                @click="$modal.hide('removeHeroModal')"></button>
                    </div>
                    <h4 class="modal-title">Remove Hero</h4>
                    <div class="modal-subtitle-gray text-center">Are you sure you want to remove this Hero? This action cannot be undone.</div>
                </div>
                <div class="modal-body d-flex flex-column align-items-center pt-3 pb-4">
                    <user-avatar size="small" :user="selectedHero" :displayName="true" subtitle="Hero"></user-avatar>
                </div>
                <div class="divider --top-12"></div>
                <div class="d-flex flex-column gap-2 p-3" >
                    <div class="d-flex flex-row justify-content-between gap-2">
                        <btn class="btn-outline-light btn-lg flex-1" @click="$modal.hide('removeHeroModal')">Cancel</btn>
                        <btn class="btn-danger btn-lg flex-1"
                             :class="{'loading': loading.add }"
                             @click="removeHero">
                            <inline-svg height="20" src="/assets/img/icons/trash-01-red.svg"></inline-svg>
                            Remove
                        </btn>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="confirmOtherCaregiverModal" height="auto" width="500px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column">
                    <div class="w-100 text-center" style="position: relative">
                        <inline-svg class="mb-2" src="/assets/img/icons/user-plus-border.svg"></inline-svg>
                        <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                                @click="$modal.hide('confirmOtherCaregiverModal')"></button>
                    </div>
                    <h4 class="modal-title">{{selectedCaregiver.name}} is about to become the Administrator</h4>
                    <div class="modal-subtitle-gray text-center">Please note that you will loose access to rights like:</div>
                </div>
                <div class="modal-body d-flex flex-column align-items-center pt-3 pb-4">
                    <ul class="modal-subtitle-gray mb-4">
                        <li>managing all of the Hero’s Card Decks and activities;</li>
                        <li>adding and removing team members.</li>
                    </ul>
                    <div class="d-flex flex-row align-items-center gap-3">
                        <user-avatar size="small" :user="selectedCaregiver" :displayName="true" :subtitle="selectedCaregiver.profession"></user-avatar>
                        <inline-svg src="/assets/img/icons/arrow-right.svg"></inline-svg>
                        <user-avatar size="small" :user="selectedCaregiver" :displayName="true" subtitle="Admin"></user-avatar>
                    </div>
                </div>
                <div class="divider --top-12"></div>
                <div class="d-flex flex-column gap-2 p-3" >
                    <div class="d-flex flex-row justify-content-between gap-2">
                        <btn class="btn-outline-light btn-lg flex-1"
                             @click="$modal.hide('confirmOtherCaregiverModal')">
                            Cancel
                        </btn>
                        <btn class="btn-primary btn-lg flex-1"
                             :class="{'loading': loading.assign }"
                             @click="assignAnotherCaregiver">
                            Confirm
                        </btn>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar.vue";
import {modelListMixin} from '/src/mixins/modelListMixin'
import AvatarGroup from "@/components/AvatarGroup.vue";

export default {
  name: 'HeroesTable',
  props: ['value', 'type'],
  mixins: [modelListMixin],
  components: {AvatarGroup, UserAvatar},
  data() {
    return {
      loading: {
        selectedHeroCaregivers: false,
        assign: false,
      },
      selected_value: null,
      options: [],
      data: {
        data: []
      },
      selectedHeroCaregivers: [],
      selectedCaregiver: {
        id: '',
        name: ''
      },
      selectedHero: {
        name: '',
        image: '',
      },
    };
  },
  mounted() {
    this.getData();
    this.$events.$on('loadHeroes', this.getData);
  },
  methods: {
    getData() {
      this.loading.data = true;
      this.$http.post("/hero/list", this.filters)
        .then((res) => {
          this.data = res.body.data;
          this.loading.data = false;
        })
        .catch((error) => {
          this.loading.data = false;
        });
    },
    showRemoveHeroModal(hero) {
      this.selectedHero = hero;
      if (hero.is_main_caregiver) {
        this.removeHeroAsMainCaregiver(hero);
      } else {
        this.$modal.show('removeHeroModal')
      }
    },
    makeAdmin() {
      this.$modal.hide('removeHeroAsAdminModal');
      this.$modal.show('confirmOtherCaregiverModal');
    },
    removeHero(removeAllTeamMembers = false) {
      //removeAllTeamMembers has to be true if caregiver wants to delete hero without assigning other caregiver, so we need to remove all team members
      this.loading.remove = true;
      this.$http.post("/hero/remove", {hero_id: this.selectedHero.id, current_date: new Date(), remove_all: removeAllTeamMembers})
        .then(() => {
          this.$events.emit('loadHeroes');
          this.$modal.hide('removeHeroModal')
          this.$modal.hide('removeHeroAsAdminModal');
          this.loading.remove = false;
        })
        .catch(() => {
          this.loading.remove = false;
        });
    },
    removeHeroAsMainCaregiver(hero) {
      this.loading.selectedHeroCaregivers = true;
      this.$http.post("/hero/get-caregivers", {id: hero.id})
        .then((res) => {
          this.selectedHeroCaregivers = res.body.data.caregivers;
          this.loading.selectedHeroCaregivers = false;
          if (this.selectedHeroCaregivers.length) {
            this.$modal.show('removeHeroAsAdminModal');
          } else {
            this.$modal.show('removeHeroModal')
          }
        })
        .catch((error) => {
          this.loading.selectedHeroCaregivers = false;
        });
    },
    assignAnotherCaregiver() {
      this.loading.assign = true;
      this.$http.post('/hero/change-main-caregiver', { hero_id: this.selectedHero.id, caregiver_id: this.selectedCaregiver.id })
        .then(function (res) {
          this.loading.assign = false;
          this.$modal.hide('confirmOtherCaregiverModal');
          this.$events.emit('loadHeroes');
        }).catch(() => {
        this.loading.assign = false;
      });
    }
  },
};
</script>
